import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { environment } from '../../../../environments/environment';
import { IToken } from '../../../utils/interfaces/token';
import { SessionTokenService } from '../session-token.service';

export const hasProfileandBranchGuard: CanActivateChildFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const sessionTokenService = inject(SessionTokenService);
  const userMe = sessionTokenService.getUserMe();
  
  let hasPermission = !!userMe?.branches?.length && !!userMe?.roleId;

  if (userMe?.roleId && userMe.roleId === environment.profileADMId) {
    hasPermission = true;
  }

  if (!hasPermission) {
    inject(Router).navigate(['auth/without-permission']);
    inject(SessionTokenService).closeSession();
  }

  return hasPermission;
};
